module.exports = __webpack_public_path__ + "img/disco.d9ab6f1d.svg";